var React = require('react');

function Pinterest (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ffffff","d":"M12.326 0C5.747.001 2.25 4.216 2.25 8.812c0 2.131 1.191 4.79 3.098 5.633.544.245.472-.054.94-1.844a.425.425 0 00-.102-.417c-2.726-3.153-.532-9.635 5.751-9.635 9.093 0 7.394 12.582 1.582 12.582-1.498 0-2.614-1.176-2.261-2.631.428-1.733 1.266-3.596 1.266-4.845 0-3.148-4.69-2.681-4.69 1.49 0 1.289.456 2.159.456 2.159S6.781 17.4 6.501 18.539c-.474 1.928.064 5.049.111 5.318.029.148.195.195.288.073.149-.195 1.973-2.797 2.484-4.678.186-.685.949-3.465.949-3.465.503.908 1.953 1.668 3.498 1.668 4.596 0 7.918-4.04 7.918-9.053C21.733 3.596 17.62 0 12.326 0z"}));
}

Pinterest.defaultProps = {"height":"22","viewBox":"0 0 24 24","width":"22"};

module.exports = Pinterest;

Pinterest.default = Pinterest;
